import React from 'react';
import InputCanvas from './InputCanvas';
import { BrushsizePickerSlider, normSizeToSliderValue, sliderValueToNormSize } from '../Drawing/BrushsizePickerSlider';
import BrushsizePicker from '../Drawing/BrushsizePicker';
import ActionTypes from '../../Models/ActionTypes';
import ColorPicker from './ColorPicker';
import ColorPickerPreview from './ColorPickerPreview';
import update from 'immutability-helper';
import ReactTooltip from 'react-tooltip';
import { isMobile } from 'react-device-detect';
class DrawableCanvas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            color: '#000000',
            penSize: 0.01,
            markerSize: 0.04,
            actionType: ActionTypes.PEN,
            redoBuffer: [],
            redraw: Date.now(),
            displayPicker: true,
        };

        if (isMobile) {
            this.state.penSelectedIndex = 1;
            this.state.markerSelectedIndex = 3;
        }

        this.handleInputStart = this.handleInputStart.bind(this);
        this.handleInputEnd = this.handleInputEnd.bind(this);
        this.handleInputMove = this.handleInputMove.bind(this);

        this.handleHoverStart = this.handleHoverStart.bind(this);
        this.handleHoverEnd = this.handleHoverEnd.bind(this);

        this.handleBrushSizeUpdated = this.handleBrushSizeUpdated.bind(this);
        this.handleColorUpdated = this.handleColorUpdated.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.undo = this.undo.bind(this);
        this.redo = this.redo.bind(this);

        this.handleMarker = this.handleMarker.bind(this);
        this.handlePen = this.handlePen.bind(this);
    }

    componentDidMount() {
        window.Mousetrap.bind('mod+z', () => this.undo());
        window.Mousetrap.bind('mod+shift+z', () => this.redo());
        window.Mousetrap.bind('mod+y', () => this.redo());
        window.Mousetrap.bind('+', () => this.handleScroll(0.15));
        window.Mousetrap.bind('-', () => this.handleScroll(-0.15));
        window.Mousetrap.bind('f', () => this.handlePen());
        window.Mousetrap.bind('b', () => this.handleMarker());
    }

    componentWillUnmount() {
        window.Mousetrap.unbind('mod+z');
        window.Mousetrap.unbind('mod+y');
        window.Mousetrap.unbind('mod+shift+z');
        window.Mousetrap.unbind('+');
        window.Mousetrap.unbind('-');
        window.Mousetrap.unbind('f');
        window.Mousetrap.unbind('b');
    }

    getStrokeSize(state) {
        state = state ?? this.state
        switch (this.state.actionType) {
            case ActionTypes.PEN:
                return this.state.penSize;
            case ActionTypes.MARKER:
                return this.state.markerSize;
        }
        return 0;
    }

    getSelectedBrushIndex() {
        switch (this.state.actionType) {
            case ActionTypes.PEN:
                return this.state.penSelectedIndex;
            case ActionTypes.MARKER:
                return this.state.markerSelectedIndex;
        }
    }

    latestPathAdded(canvasData) {
        var latestPen = canvasData.pen.paths.length ? canvasData.pen.paths[canvasData.pen.paths.length - 1] : null;
        var latestMarker = canvasData.marker.paths.length ? canvasData.marker.paths[canvasData.marker.paths.length - 1] : null;

        var data = {
            pen: {
                paths: []
            },
            marker: {
                paths: []
            }
        };


        if (!latestPen && !latestMarker) {
            return data
        }

        var type;
        if (!latestPen || (latestMarker && latestPen.createdAt < latestMarker.createdAt)) {
            data.marker.paths = [latestMarker]
            type = ActionTypes.MARKER
        } else {
            data.pen.paths = [latestPen]
            type = ActionTypes.PEN
        }
        return {
            data: data,
            type: type
        };
    }

    handleInputStart(x, y) {
        this.props.onCanvasDataChange(
            update(this.props.canvasData, {
                [this.state.actionType]: {
                    paths: {
                        $push: [{
                            color: this.state.color,
                            strokeSize: this.getStrokeSize(),
                            createdAt: new Date().getTime(),
                            points: [{
                                x: x,
                                y: y
                            }]
                        }]
                    }
                },
                brushPreview: {
                    $set: null
                }
            })
        )
        this.setState((state) => {
            return update(state, {
                redoBuffer: []
            });
        })
    }

    handleColorUpdated(color) {
        this.setState({
            color: color
        });
    }

    handleInputMove(x, y) {
        this.props.onCanvasDataChange(
            update(this.props.canvasData, {
                [this.state.actionType]: {
                    paths: {
                        [this.props.canvasData[this.state.actionType].paths.length - 1]: {
                            points: {
                                $push: [{
                                    x: x,
                                    y: y
                                }]
                            }
                        }
                    }
                }
            })
        )
    }

    handleInputEnd(x, y) {
        if (x && y) {
            this.handleInputMove(x, y);
        }
        this.props.onPathAdded(this.latestPathAdded(this.props.canvasData).data)
    }

    handleBrushSizeUpdated(newSize, brushIndex = -1) {
        if (brushIndex !== -1) {
            switch (this.state.actionType) {
                case ActionTypes.PEN:
                    this.state.penSelectedIndex = brushIndex;
                    break;
                case ActionTypes.MARKER:
                    this.state.markerSelectedIndex = brushIndex;
                    break;
            }
        }
        this.setState((state) => {
            return update(state, {
                [state.actionType + "Size"]: {
                    $set: newSize
                }
            });
        })
        if (this.props.canvasData.brushPreview) {
            this.props.onCanvasDataChange(
                update(this.props.canvasData, {
                    brushPreview: {
                        strokeSize: {
                            $set: newSize
                        }
                    }
                })
            );
            this.setState((state) => {
                return update(state, {
                    [state.actionType + "Size"]: {
                        $set: newSize
                    }
                });
            })
        }
    }

    handleHoverStart(x, y) {
        this.props.onCanvasDataChange(
            update(this.props.canvasData, {
                brushPreview: {
                    $set: {
                        type: this.state.actionType,
                        color: this.state.color,
                        strokeSize: this.getStrokeSize(),
                        pos: {
                            x: x,
                            y: y
                        }
                    }
                }
            })
        )
    }

    handleHoverEnd() {
        this.props.onCanvasDataChange(
            update(this.props.canvasData, {
                brushPreview: {
                    $set: null
                }
            })
        )
    }

    undo() {
        var canvasData = Object.assign({}, this.props.canvasData);

        var latestPen = canvasData.pen.paths.length ? canvasData.pen.paths[canvasData.pen.paths.length - 1] : null;
        var latestMarker = canvasData.marker.paths.length ? canvasData.marker.paths[canvasData.marker.paths.length - 1] : null;

        if (!latestPen && !latestMarker) {
            return;
        }

        var newBuffer = null;

        if (!latestPen || (latestMarker && latestPen.createdAt < latestMarker.createdAt)) {
            newBuffer = {
                type: ActionTypes.MARKER,
                value: latestMarker
            };
            canvasData.marker.paths = canvasData.marker.paths.slice(0, canvasData.marker.paths.length - 1);
            this.props.onUndoMarker();
        } else {
            newBuffer = {
                type: ActionTypes.PEN,
                value: latestPen
            };
            canvasData.pen.paths = canvasData.pen.paths.slice(0, canvasData.pen.paths.length - 1);
            this.props.onUndoPen();
        }
        this.props.onCanvasDataChange(canvasData)
        this.setState({
            redoBuffer: this.state.redoBuffer.concat(newBuffer),
            redraw: Date.now(),
        });
    }

    redo() {
        if (!this.state.redoBuffer.length) {
            return
        }
        var redoValue = this.state.redoBuffer[this.state.redoBuffer.length - 1]
        var canvasData = Object.assign({}, this.props.canvasData);
        switch (redoValue.type) {
            case ActionTypes.PEN:
                canvasData.pen.paths = canvasData.pen.paths.concat(redoValue.value);
                break;
            case ActionTypes.MARKER:
                canvasData.marker.paths = canvasData.marker.paths.concat(redoValue.value);
                break;
        }
        this.props.onPathAdded(this.latestPathAdded(canvasData).data)
        this.props.onCanvasDataChange(canvasData)
        this.setState({
            redoBuffer: this.state.redoBuffer.slice(0, this.state.redoBuffer.length - 1)
        });
    }

    handleMarker() {
        this.setState({
            actionType: ActionTypes.MARKER
        });
    }

    handlePen() {
        this.setState({
            actionType: ActionTypes.PEN
        });
    }

    handleScroll(deltaY) {
        var value = normSizeToSliderValue(this.getStrokeSize());
        value += deltaY
        value = Math.min(Math.max(value, 0), 1)
        value = sliderValueToNormSize(value);
        this.handleBrushSizeUpdated(value);
    }

    getDrawing() {
        return {
            penPaths: this.props.canvasData.pen.paths,
            markerPaths: this.props.canvasData.marker.paths
        };
    }

    render() {

        const buttonStyle = {
            color: "black",
            background: "none",
            border: "none",
            padding: ".5em",
            fontSize: "inherit",
            cursor: "pointer",
        }
        const selectedButtonStyle = {
            color: "black",
            background: "none",
            padding: ".5em",
            border: "2px solid #000000",
            fontSize: "inherit",
            cursor: "pointer",
        }

        const actionsFlexbar = {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            width: this.props.width
        }

        const actionSectionFlexbar = {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center"
        }

        return (
            <div>
                <InputCanvas canvasData={this.props.canvasData} width={this.props.width} border={'2px solid black'} redraw={this.state.redraw}
                    onInputStart={this.handleInputStart}
                    onInputEnd={this.handleInputEnd}
                    onInputMove={this.handleInputMove}
                    onHoverStart={this.handleHoverStart}
                    onHoverEnd={this.handleHoverEnd}
                    onScroll={this.handleScroll} />
                <div style={actionsFlexbar}>
                    <div style={actionSectionFlexbar}>
                        {isMobile ?
                            <BrushsizePicker dataTip="brush size" canvasWidth={this.props.width} nBrushsizes={6} valueUpdated={this.handleBrushSizeUpdated} selectedIndex={this.getSelectedBrushIndex()} /> :
                            <BrushsizePickerSlider dataTip="brush size" valueUpdated={this.handleBrushSizeUpdated} value={this.getStrokeSize()} />
                        }

                        <button data-tip="pen (f)" style={this.state.actionType === ActionTypes.PEN ? selectedButtonStyle : buttonStyle} onClick={this.handlePen}><img src={process.env.PUBLIC_URL + '/assets/icons/128/pen.jpg'} alt="pen" style={{ width: "2em" }} /></button>
                        <button data-tip="background fill (b)" style={this.state.actionType === ActionTypes.MARKER ? selectedButtonStyle : buttonStyle} onClick={this.handleMarker}><img src={process.env.PUBLIC_URL + '/assets/icons/128/paint_roller.jpg'} alt="highlighter" style={{ width: "2em" }} /></button>
                    </div>
                    <div style={actionSectionFlexbar}>
                        <ColorPickerPreview dataTip="color picker" color={this.state.color} displayPicker={this.state.displayPicker} setDisplayPicker={(b) => this.setState({ displayPicker: b })}></ColorPickerPreview>
                        <button data-tip="undo (ctrl+z)" style={buttonStyle} onClick={this.undo}><img src={process.env.PUBLIC_URL + '/assets/icons/128/undo.jpg'} alt="undo" style={{ width: "2em" }} className="icon" /></button>
                        <button data-tip="redo (ctrl+y)" style={buttonStyle} onClick={this.redo}><img src={process.env.PUBLIC_URL + '/assets/icons/128/redo.jpg'} alt="redo" style={{ width: "2em" }} className="icon" /></button>
                    </div>
                </div>
                <div style={actionsFlexbar}>
                    <ColorPicker visible={this.state.displayPicker} onChange={this.handleColorUpdated} />
                </div>
                <ReactTooltip place="top" effect="solid" delayShow={500} type="dark" />
            </div>
        );
    }
}

export default DrawableCanvas;
